import { useCallback } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useApiMutation } from '@BUP/hooks/useApiMutation'

export const useCreateTeacherRegistrations = ({ onSuccess } = {}) => {
  const queryClient = useQueryClient()
  const mutation = useApiMutation(
    'schools',
    ({ courseId }) => `courses/${courseId}/registrations`,
    'post',
    {
      onSuccess: () => {
        queryClient.removeQueries({ queryKey: ['enrollments-by-role-type'], type: 'inactive' })
        queryClient.removeQueries({ queryKey: ['registrations'], type: 'inactive' })
        queryClient.invalidateQueries({ queryKey: ['enrollments-by-role-type'] })
        queryClient.invalidateQueries({ queryKey: ['registrations'] })
        onSuccess?.()
      },
      onError: error => {
        console.error(error)
      }
    },
    { authenticated: true, version: 4 }
  )
  const { mutateAsync } = mutation

  const createRegistration = useCallback(async (enrollmentId, courseId) => {
    return mutateAsync({
      courseId,
      data: {
        enrollmentId,
        tags: ['course:role:main-teacher']
      }
    })
      .catch(error => {
        console.error(error)
      })
  }, [mutateAsync])

  return {
    createRegistration,
    loadingRegistration: mutation.isPending
  }
}
